import { useQuery } from '@tanstack/react-query';
import { cardListMapper } from '../libs/cardListAdapter';
import { userCardAPI } from '../api/userCardAPI';
import { get } from 'lodash';
export const useGetCardList = () => {
  const initData = { cardList: cardListMapper() };
  const { data = initData, isLoading } = useQuery({
    queryKey: ['card-list'],
    queryFn: async () => await userCardAPI.getAll(),
    select: data => ({
      cardList: cardListMapper(get(data, 'data.cards')),
    }),
  });
  return {
    ...data,
    isLoading,
  };
};
